function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40",
  height: "27",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "#CCC",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  className: styles["block"] || "block",
  d: "M17.194 0H40v6.295H17.194zM4.518 0h7.209v6.295H4.518zM17.194 20.581H40v6.295H17.194zM4.518 20.581h7.209v6.295H4.518zM0 10.29h22.806v6.295H0zM28.41 10.29h7.209v6.295H28.41z"
}))));